import './bootstrap';

window.loadTabContent = function (tabContainer, targetPane, dataUrl, isFirstLoad) {
    if (dataUrl) {
        var scrollTabTop = tabContainer.offset().top - $('#site-nav').outerHeight();

        fetch(dataUrl, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => {
                if (!response.ok) throw new Error('Network response failure');
                return response.text();
            })
            .then(html => {
                $('#' + $(targetPane).attr('id')).html(html);
                if (!isFirstLoad) $(window).scrollTop(scrollTabTop);
            })
            .catch(error => {
                '#' + $(targetPane).attr('id').html('<div class="alert alert-danger">Failed to load content.</div>');
                console.error('AJAX Error:', error);
            });
    }
};
